export const CABINET_PAGES = [
  {
    slug: "a-propos",
    fr: {
      eyebrow: "Le Cabinet",
      title: "Fondé sur la précision, la transparence et la confiance.",
      intro:
        "Columbus Management Consulting GmbH est une société suisse indépendante de conseil en investissement immobilier et en structuration de patrimoine, avec un ancrage à Zurich.",
      chips: ["GmbH suisse", "Zurich", "Indépendant"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Notre raison d'être : le succès de long terme",
          paragraphs: [
            "Le cabinet est né d'une conviction simple : les défis patrimoniaux et immobiliers complexes méritent des solutions disciplinées, documentées et menées par des conseillers qui ont une véritable expérience de terrain — pas seulement théorique.",
            "Notre héritage suisse informe notre approche de la structure, de la gouvernance et de la création de valeur durable. Notre ancrage zurichois nous donne un accès direct aux flux de capitaux suisses et européens et aux véhicules d'investissement internationaux.",
            "Notre succès repose sur la qualité d'un conseil objectif et impartial, offert aux particuliers fortunés, aux familles, aux entrepreneurs et aux institutions.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Quatre principes, une seule exigence : vos intérêts d'abord.",
          items: [
            { title: "Responsabilité du conseil", desc: "Chaque transaction est pour nous une opportunité de confirmer la réputation d'une société de conseil compétente." },
            { title: "La qualité des rapports", desc: "Les études réalisées pour vous sont individuelles, fiables et entièrement dédiées — jamais reprises de sources ouvertes." },
            { title: "Intégrité", desc: "Transparence et honnêteté à chaque étape : la base de relations qui durent depuis des années." },
            { title: "Solutions sur mesure", desc: "Une compréhension approfondie de vos défis, pour des stratégies personnalisées, innovantes et efficaces." },
          ],
        },
        {
          type: "timeline",
          theme: "light",
          title: "Notre parcours",
          items: [
            { year: "2008", text: "Les racines du cabinet : conseil en gestion et investissement pour dirigeants et familles." },
            { year: "2011", text: "Inscription de Columbus Management Consulting GmbH au registre du commerce du canton de Zurich, le 01.03.2011." },
            { year: "2013", text: "Extension de la pratique au conseil transfrontalier et à la structuration de capital." },
            { year: "2017", text: "Lancement de la pratique dédiée aux structures d'investissement et véhicules immobiliers." },
            { year: "2021", text: "Formalisation de l'activité de structuration sociétaire et de gouvernance." },
            { year: "Aujourd'hui", text: "Un modèle de conseil senior pour le capital privé, l'immobilier et la stratégie transfrontalière." },
          ],
        },
        {
          type: "quote",
          theme: "dark",
          text: "« Nous ne conseillons à nos clients que ce que nous mettrions en œuvre pour nos propres entreprises. Cette règle n'a pas changé depuis nos débuts. »",
          author: "La direction — Columbus Management Consulting GmbH",
        },
      ],
    },
    en: {
      eyebrow: "The Firm",
      title: "Founded on precision, transparency and trust.",
      intro:
        "Columbus Management Consulting GmbH is an independent Swiss advisory firm for real estate investment and wealth structuring, rooted in Zurich.",
      chips: ["Swiss GmbH", "Zurich", "Independent"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Our purpose: long-term success",
          paragraphs: [
            "The firm was born of a simple conviction: complex wealth and real estate challenges deserve disciplined, documented solutions delivered by advisors with genuine operational experience — not just theory.",
            "Our Swiss heritage informs our approach to structure, governance and durable value creation. Our Zurich base gives us direct access to Swiss and European capital flows and international investment vehicles.",
            "Our success rests on the quality of objective, impartial advice offered to high-net-worth individuals, families, entrepreneurs and institutions.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Four principles, one requirement: your interests first.",
          items: [
            { title: "Advisory accountability", desc: "Every transaction is an opportunity to confirm our reputation as a competent advisory firm." },
            { title: "Quality of reporting", desc: "The studies produced for you are individual, reliable and fully dedicated — never lifted from open sources." },
            { title: "Integrity", desc: "Transparency and honesty at every step: the basis of relationships that have lasted for years." },
            { title: "Bespoke solutions", desc: "A deep understanding of your challenges, for personalised, innovative and effective strategies." },
          ],
        },
        {
          type: "timeline",
          theme: "light",
          title: "Our journey",
          items: [
            { year: "2008", text: "The firm's roots: management and investment consulting for executives and families." },
            { year: "2011", text: "Registration of Columbus Management Consulting GmbH in the commercial register of the canton of Zurich, on 01.03.2011." },
            { year: "2013", text: "Expansion of the practice into cross-border advisory and capital structuring." },
            { year: "2017", text: "Launch of the dedicated investment structures and real estate vehicles practice." },
            { year: "2021", text: "Corporate structuring and governance activity formalised." },
            { year: "Today", text: "A senior-led advisory model for private capital, real estate and cross-border strategy." },
          ],
        },
        {
          type: "quote",
          theme: "dark",
          text: "\u00AB We only advise our clients on what we would implement for our own companies. That rule has not changed since we started. \u00BB",
          author: "The leadership — Columbus Management Consulting GmbH",
        },
      ],
    },
    de: {
      eyebrow: "Das Unternehmen",
      title: "Gegründet auf Präzision, Transparenz und Vertrauen.",
      intro:
        "Die Columbus Management Consulting GmbH ist eine unabhängige Schweizer Beratungsgesellschaft für Immobilieninvestitionen und Vermögensstrukturierung — verwurzelt in Zürich.",
      chips: ["Schweizer GmbH", "Zürich", "Unabhängig"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Unser Auftrag: langfristiger Erfolg",
          paragraphs: [
            "Das Unternehmen entstand aus einer einfachen Überzeugung: Komplexe Vermögens- und Immobilienfragen verdienen disziplinierte, dokumentierte Lösungen — umgesetzt von Beratern mit echter Praxiserfahrung, nicht nur Theorie.",
            "Unser Schweizer Erbe prägt unseren Ansatz in Struktur, Governance und dauerhafter Wertschöpfung. Unser Zürcher Standort verschafft uns direkten Zugang zu Schweizer und europäischen Kapitalströmen und internationalen Investmentvehikeln.",
            "Unser Erfolg beruht auf der Qualität objektiver, unabhängiger Beratung für vermögende Privatpersonen, Familien, Unternehmer und Institutionen.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Vier Prinzipien, ein Anspruch: Ihre Interessen zuerst.",
          items: [
            { title: "Beratungsverantwortung", desc: "Jede Transaktion ist für uns eine Gelegenheit, unseren Ruf als kompetente Beratungsgesellschaft zu bestätigen." },
            { title: "Qualität der Analysen", desc: "Die für Sie erstellten Studien sind individuell, verlässlich und vollständig dediziert — nie aus offenen Quellen übernommen." },
            { title: "Integrität", desc: "Transparenz und Ehrlichkeit bei jedem Schritt: die Grundlage von Beziehungen, die seit Jahren bestehen." },
            { title: "Massgeschneiderte Lösungen", desc: "Ein tiefes Verständnis Ihrer Herausforderungen für personalisierte, innovative und wirksame Strategien." },
          ],
        },
        {
          type: "timeline",
          theme: "light",
          title: "Unser Weg",
          items: [
            { year: "2008", text: "Die Wurzeln des Unternehmens: Management- und Investmentberatung für Führungskräfte und Familien." },
            { year: "2011", text: "Eintragung der Columbus Management Consulting GmbH ins Handelsregister des Kantons Zürich am 01.03.2011." },
            { year: "2013", text: "Ausweitung der Praxis auf grenzüberschreitende Beratung und Kapitalstrukturierung." },
            { year: "2017", text: "Aufbau der Praxis für Investmentstrukturen und Immobilienvehikel." },
            { year: "2021", text: "Formalisierung der Gesellschaftsstrukturierungs- und Governance-Tätigkeit." },
            { year: "Heute", text: "Ein seniorgeführtes Beratungsmodell für Privatkapital, Immobilien und grenzüberschreitende Strategie." },
          ],
        },
        {
          type: "quote",
          theme: "dark",
          text: "« Wir empfehlen unseren Kunden nur, was wir auch für unsere eigenen Unternehmen umsetzen würden. An dieser Regel hat sich seit unseren Anfängen nichts geändert. »",
          author: "Die Geschäftsleitung — Columbus Management Consulting GmbH",
        },
      ],
    },
  },
  {
    slug: "equipe",
    fr: {
      eyebrow: "Le Cabinet · Équipe",
      title: "Les personnes derrière chaque mandat.",
      intro:
        "Une équipe senior et restreinte — direction, conseil, investissement et opérations — construite pour la clarté, la discrétion et une exécution responsable.",
      chips: ["Équipes seniors", "Pas de juniorisation"],
      sections: [
        {
          type: "team",
          theme: "light",
          title: "Direction",
          sub: "Les décideurs seniors qui portent la stratégie, la gouvernance et la relation client du cabinet.",
          groups: [
            {
              title: "Direction exécutive",
              members: [
                { initials: "TR", name: "Thomas Peter Ruppelt", role: "Chief Executive Officer", bio: "Direction générale du cabinet : stratégie, gouvernance et relation client." },
                { initials: "PO", name: "Paul Oeri", role: "Director", bio: "Direction des missions et coordination des dossiers clients." },
                { initials: "PB", name: "Philippe Berda", role: "Chief Financial Officer", bio: "Pilotage financier, reporting et contrôle de gestion." },
                { initials: "AD", name: "Andrea Despature", role: "Chief Investment Officer", bio: "Sélection et suivi des investissements, diligence et allocation d'actifs." },
              ],
            },
            {
              title: "Conseil & gestion de fortune",
              members: [
                { initials: "AF", name: "Alexandre Fournier", role: "Wealth Manager", bio: "Gestion de patrimoine et accompagnement personnalisé des clients." },
                { initials: "JP", name: "Joseph Puech", role: "Tax & Jurisdiction Consultant", bio: "Considérations juridictionnelles, coordination fiscale et structuration." },
                { initials: "PZ", name: "Patrick Zorbibe", role: "Business Consultant", bio: "Conseil opérationnel et accompagnement des mandats clients." },
                { initials: "PR", name: "Patricia Ruppelt", role: "Business Consultant", bio: "Conseil en développement et structuration des activités." },
                { initials: "VM", name: "Valerie Murray", role: "Business Consultant", bio: "Conseil en organisation et conduite de projets clients." },
              ],
            },
            {
              title: "Conformité & opérations",
              members: [
                { initials: "AS", name: "Alex Song", role: "Compliance Officer", bio: "Revue de conformité, standards documentaires et contrôles d'entrée en relation." },
                { initials: "MJ", name: "Melanie Janssen", role: "Secretary", bio: "Coordination administrative et support de la direction." },
              ],
            },
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Quatre engagements au service de vos intérêts",
          items: [
            { title: "Indépendance", desc: "Aucun lien avec un réseau bancaire ou d'audit. Aucune commission sur les solutions recommandées." },
            { title: "Rigueur", desc: "Une approche analytique et documentée, du premier rendez-vous à l'exécution." },
            { title: "Confidentialité", desc: "Le respect strict de la discrétion, à chaque étape de la relation." },
            { title: "Long terme", desc: "Un suivi régulier et une révision annuelle de chaque dossier." },
          ],
        },
      ],
    },
    en: {
      eyebrow: "The Firm · Team",
      title: "The people behind every mandate.",
      intro:
        "A small senior team — leadership, advisory, investment and operations — built for clarity, discretion and accountable execution.",
      chips: ["Senior teams", "No junior leverage model"],
      sections: [
        {
          type: "team",
          theme: "light",
          title: "Leadership",
          sub: "The senior decision makers carrying the firm's strategy, governance and client relationships.",
          groups: [
            {
              title: "Executive leadership",
              members: [
                { initials: "TR", name: "Thomas Peter Ruppelt", role: "Chief Executive Officer", bio: "Leads the firm: strategy, governance and client relationships." },
                { initials: "PO", name: "Paul Oeri", role: "Director", bio: "Directs engagements and coordinates client files." },
                { initials: "PB", name: "Philippe Berda", role: "Chief Financial Officer", bio: "Financial steering, reporting and management control." },
                { initials: "AD", name: "Andrea Despature", role: "Chief Investment Officer", bio: "Investment selection and monitoring, diligence and asset allocation." },
              ],
            },
            {
              title: "Advisory & wealth management",
              members: [
                { initials: "AF", name: "Alexandre Fournier", role: "Wealth Manager", bio: "Wealth management and personalised client support." },
                { initials: "JP", name: "Joseph Puech", role: "Tax & Jurisdiction Consultant", bio: "Jurisdictional considerations, tax coordination and structuring." },
                { initials: "PZ", name: "Patrick Zorbibe", role: "Business Consultant", bio: "Operational consulting and client mandate support." },
                { initials: "PR", name: "Patricia Ruppelt", role: "Business Consultant", bio: "Business development and structuring advisory." },
                { initials: "VM", name: "Valerie Murray", role: "Business Consultant", bio: "Organisation advisory and client project delivery." },
              ],
            },
            {
              title: "Compliance & operations",
              members: [
                { initials: "AS", name: "Alex Song", role: "Compliance Officer", bio: "Compliance review, documentation standards and onboarding controls." },
                { initials: "MJ", name: "Melanie Janssen", role: "Secretary", bio: "Administrative coordination and executive support." },
              ],
            },
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Four commitments serving your interests",
          items: [
            { title: "Independence", desc: "No ties to any banking or audit network. No commissions on recommended solutions." },
            { title: "Rigour", desc: "An analytical, documented approach, from first meeting to execution." },
            { title: "Confidentiality", desc: "Strict discretion at every stage of the relationship." },
            { title: "Long term", desc: "Regular monitoring and an annual review of every file." },
          ],
        },
      ],
    },
    de: {
      eyebrow: "Das Unternehmen · Team",
      title: "Die Menschen hinter jedem Mandat.",
      intro:
        "Ein kleines Senior-Team — Geschäftsleitung, Beratung, Investment und Operations — aufgebaut für Klarheit, Diskretion und verantwortungsvolle Ausführung.",
      chips: ["Senior-Teams", "Kein Junior-Modell"],
      sections: [
        {
          type: "team",
          theme: "light",
          title: "Geschäftsleitung",
          sub: "Die seniorigen Entscheidungsträger, die Strategie, Governance und Kundenbeziehungen des Unternehmens tragen.",
          groups: [
            {
              title: "Geschäftsleitung",
              members: [
                { initials: "TR", name: "Thomas Peter Ruppelt", role: "Chief Executive Officer", bio: "Leitung des Unternehmens: Strategie, Governance und Kundenbeziehungen." },
                { initials: "PO", name: "Paul Oeri", role: "Director", bio: "Leitung der Mandate und Koordination der Kundendossiers." },
                { initials: "PB", name: "Philippe Berda", role: "Chief Financial Officer", bio: "Finanzsteuerung, Reporting und Controlling." },
                { initials: "AD", name: "Andrea Despature", role: "Chief Investment Officer", bio: "Auswahl und Überwachung von Investitionen, Due Diligence und Asset-Allokation." },
              ],
            },
            {
              title: "Beratung & Vermögensverwaltung",
              members: [
                { initials: "AF", name: "Alexandre Fournier", role: "Wealth Manager", bio: "Vermögensverwaltung und persönliche Kundenbegleitung." },
                { initials: "JP", name: "Joseph Puech", role: "Tax & Jurisdiction Consultant", bio: "Jurisdiktionsfragen, Steuerkoordination und Strukturierung." },
                { initials: "PZ", name: "Patrick Zorbibe", role: "Business Consultant", bio: "Operative Beratung und Begleitung von Kundenmandaten." },
                { initials: "PR", name: "Patricia Ruppelt", role: "Business Consultant", bio: "Beratung zu Geschäftsentwicklung und Strukturierung." },
                { initials: "VM", name: "Valerie Murray", role: "Business Consultant", bio: "Organisationsberatung und Steuerung von Kundenprojekten." },
              ],
            },
            {
              title: "Compliance & Operations",
              members: [
                { initials: "AS", name: "Alex Song", role: "Compliance Officer", bio: "Compliance-Prüfung, Dokumentationsstandards und Onboarding-Kontrollen." },
                { initials: "MJ", name: "Melanie Janssen", role: "Secretary", bio: "Administrative Koordination und Unterstützung der Geschäftsleitung." },
              ],
            },
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Vier Verpflichtungen für Ihre Interessen",
          items: [
            { title: "Unabhängigkeit", desc: "Keine Verbindungen zu Bank- oder Prüfungsnetzwerken. Keine Provisionen auf empfohlene Lösungen." },
            { title: "Präzision", desc: "Ein analytischer, dokumentierter Ansatz — vom ersten Gespräch bis zur Ausführung." },
            { title: "Vertraulichkeit", desc: "Strikte Diskretion in jeder Phase der Zusammenarbeit." },
            { title: "Langer Horizont", desc: "Regelmässige Überwachung und jährliche Revision jedes Dossiers." },
          ],
        },
      ],
    },
  },
  {
    slug: "culture",
    fr: {
      eyebrow: "Le Cabinet · Culture",
      title: "Bâti sur l'expertise, animé par le sens du travail bien fait.",
      intro:
        "Ce que travailler avec nous signifie : nos valeurs, nos façons de travailler, et ce que nous recherchons chez les personnes qui nous rejoignent.",
      chips: ["Rigueur intellectuelle", "Esprit international", "Intégrité sans exception"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "De petites équipes, senior par principe",
          paragraphs: [
            "Le cabinet réunit des spécialistes — investissement, droit, finance, réglementaire, stratégie — unis par une même exigence de rigueur intellectuelle et de résultats durables.",
            "Nous travaillons en petites équipes senior. Pas de banc d'analystes juniors dont les partenaires relisent le travail à la dernière minute : chaque échange client implique les personnes qui font réellement le travail.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Nos façons de travailler",
          items: [
            { title: "La recherche d'abord", desc: "Chaque recommandation commence par des preuves : recherche propriétaire et intelligence de marché." },
            { title: "Global par conception", desc: "Des profils venus d'Europe, d'Asie et des Amériques. La diversité de perspectives est un avantage structurel." },
            { title: "Des résultats, pas des heures", desc: "Nous mesurons le succès aux résultats clients, pas aux métriques de process." },
            { title: "Apprentissage continu", desc: "Marchés, réglementations et technologies évoluent vite : nous investissons dans le développement professionnel." },
          ],
        },
        {
          type: "quote",
          theme: "light",
          text: "« Nous recrutons des personnes curieuses intellectuellement, ouvertes sur le monde, et profondément attachées au travail excellent. »",
          author: "Philosophie RH — Columbus Management Consulting GmbH",
        },
      ],
    },
    en: {
      eyebrow: "The Firm · Culture",
      title: "Built on expertise, driven by purpose.",
      intro:
        "What working with us means: our values, our ways of working, and what we look for in the people who join us.",
      chips: ["Intellectual rigour", "Global mindset", "Integrity without exception"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Small teams, senior by principle",
          paragraphs: [
            "The firm brings together specialists — investment, law, finance, regulatory, strategy — united by the same demand for intellectual rigour and lasting outcomes.",
            "We work in small, senior teams. No bench of junior analysts whose work partners review at the last minute: every client interaction involves the people who actually do the work.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Our ways of working",
          items: [
            { title: "Research first", desc: "Every recommendation begins with evidence: proprietary research and market intelligence." },
            { title: "Global by design", desc: "Professionals from Europe, Asia and the Americas. Diversity of perspective is a structural advantage." },
            { title: "Outcomes, not hours", desc: "We measure success by client outcomes, not process metrics." },
            { title: "Continuous learning", desc: "Markets, regulations and technologies evolve fast: we invest in professional development." },
          ],
        },
        {
          type: "quote",
          theme: "light",
          text: "\u00AB We hire people who are intellectually curious, globally minded, and deeply committed to excellent work. \u00BB",
          author: "People philosophy — Columbus Management Consulting GmbH",
        },
      ],
    },
    de: {
      eyebrow: "Das Unternehmen · Kultur",
      title: "Aufgebaut auf Expertise, getrieben von Anspruch.",
      intro:
        "Was die Zusammenarbeit mit uns bedeutet: unsere Werte, unsere Arbeitsweise und was wir bei Menschen suchen, die zu uns kommen.",
      chips: ["Intellektuelle Präzision", "Internationale Denkweise", "Integrität ohne Ausnahme"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Kleine Teams, aus Prinzip senior besetzt",
          paragraphs: [
            "Das Unternehmen vereint Spezialisten — Investment, Recht, Finanzen, Regulierung, Strategie — vereint durch denselben Anspruch an intellektuelle Präzision und dauerhafte Ergebnisse.",
            "Wir arbeiten in kleinen Senior-Teams. Keine Bank junger Analysten, deren Arbeit Partner in letzter Minute prüfen: Jeder Kundenkontakt bindet die Personen ein, die die Arbeit tatsächlich leisten.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Unsere Arbeitsweise",
          items: [
            { title: "Recherche zuerst", desc: "Jede Empfehlung beginnt mit Belegen: eigene Research- und Marktintelligenz." },
            { title: "Global von Anfang an", desc: "Profile aus Europa, Asien und Amerika. Vielfalt der Perspektiven ist ein struktureller Vorteil." },
            { title: "Ergebnisse, nicht Stunden", desc: "Wir messen Erfolg an Kundenergebnissen, nicht an Prozesskennzahlen." },
            { title: "Kontinuierliches Lernen", desc: "Märkte, Regulierung und Technologien entwickeln sich schnell: Wir investieren in Weiterbildung." },
          ],
        },
        {
          type: "quote",
          theme: "light",
          text: "« Wir stellen Menschen ein, die intellektuell neugierig, weltoffen und exzellenter Arbeit tief verpflichtet sind. »",
          author: "Personalphilosophie — Columbus Management Consulting GmbH",
        },
      ],
    },
  },
  {
    slug: "valeurs",
    fr: {
      eyebrow: "Le Cabinet · Valeurs",
      title: "Les fondations de notre approche.",
      intro: "Six principes qui guident chaque mission, chaque transaction et chaque décision du cabinet.",
      chips: [],
      sections: [
        {
          type: "cards",
          theme: "light",
          title: "Six valeurs opérationnelles",
          items: [
            { title: "Intégrité", desc: "Chaque acquisition, financement et investissement est mené avec honnêteté, transparence et responsabilité. Notre réputation se construit transaction après transaction." },
            { title: "Solutions globales", desc: "Nous combinons vision stratégique et capacité d'exécution. Nous ne nous contentons pas de conseiller — nous livrons." },
            { title: "Focus client", desc: "Chaque mandat est structuré autour de vos objectifs, votre calendrier et vos contraintes — et nous nous engageons sur les résultats." },
            { title: "Discipline de recherche", desc: "Les meilleures décisions reposent sur les meilleures informations : analyse de marché rigoureuse et compréhension réglementaire." },
            { title: "Pensée long terme", desc: "Nous structurons pour la durabilité, pas pour l'optimisation de court terme. C'est pourquoi nos clients reviennent, cycle après cycle." },
            { title: "Confidentialité", desc: "Informations, structures et stratégies ne sont jamais discutées ni référencées sans autorisation explicite." },
          ],
        },
        {
          type: "quote",
          theme: "dark",
          text: "« Ces valeurs ne sont pas aspirationnelles. Elles sont opérationnelles. »",
        },
      ],
    },
    en: {
      eyebrow: "The Firm · Core values",
      title: "The foundations of our approach.",
      intro: "Six principles guiding every engagement, every transaction and every decision at the firm.",
      chips: [],
      sections: [
        {
          type: "cards",
          theme: "light",
          title: "Six operational values",
          items: [
            { title: "Integrity", desc: "Every acquisition, financing and investment is conducted with honesty, transparency and accountability. Our reputation is built one transaction at a time." },
            { title: "Global solutions", desc: "We combine strategic insight with execution capability. We do not merely advise — we deliver." },
            { title: "Client focus", desc: "Every mandate is structured around your objectives, timeline and constraints — and we hold ourselves accountable to outcomes." },
            { title: "Research discipline", desc: "The best decisions rest on the best information: rigorous market analysis and regulatory understanding." },
            { title: "Long-term thinking", desc: "We structure for durability, not short-term optimisation. That is why clients return, cycle after cycle." },
            { title: "Confidentiality", desc: "Information, structures and strategies are never discussed or referenced without explicit authorisation." },
          ],
        },
        {
          type: "quote",
          theme: "dark",
          text: "\u00AB These values are not aspirational. They are operational. \u00BB",
        },
      ],
    },
    de: {
      eyebrow: "Das Unternehmen · Werte",
      title: "Die Grundlagen unseres Ansatzes.",
      intro: "Sechs Prinzipien, die jedes Mandat, jede Transaktion und jede Entscheidung des Unternehmens leiten.",
      chips: [],
      sections: [
        {
          type: "cards",
          theme: "light",
          title: "Sechs operative Werte",
          items: [
            { title: "Integrität", desc: "Jeder Erwerb, jede Finanzierung und jede Investition wird mit Ehrlichkeit, Transparenz und Verantwortung durchgeführt. Unser Ruf entsteht Transaktion für Transaktion." },
            { title: "Globale Lösungen", desc: "Wir verbinden strategischen Weitblick mit Umsetzungsstärke. Wir beraten nicht nur — wir liefern." },
            { title: "Kundenfokus", desc: "Jedes Mandat ist um Ihre Ziele, Ihren Zeitplan und Ihre Rahmenbedingungen strukturiert — und wir messen uns an Ergebnissen." },
            { title: "Research-Disziplin", desc: "Die besten Entscheidungen beruhen auf den besten Informationen: rigorose Marktanalyse und regulatorisches Verständnis." },
            { title: "Langfristiges Denken", desc: "Wir strukturieren für Dauerhaftigkeit, nicht für kurzfristige Optimierung. Deshalb kehren Kunden Zyklus für Zyklus zurück." },
            { title: "Vertraulichkeit", desc: "Informationen, Strukturen und Strategien werden niemals ohne ausdrückliche Genehmigung besprochen oder referenziert." },
          ],
        },
        {
          type: "quote",
          theme: "dark",
          text: "« Diese Werte sind nicht aspirational. Sie sind operativ. »",
        },
      ],
    },
  },
  {
    slug: "carrieres",
    fr: {
      eyebrow: "Le Cabinet · Carrières",
      title: "Construisez votre carrière au service de mandats qui comptent.",
      intro:
        "Nous recherchons des personnes qui combinent rigueur analytique, perspective internationale et curiosité sincère pour les marchés, l'immobilier et le capital.",
      chips: ["Zurich", "Équipe senior"],
      sections: [
        {
          type: "grid",
          theme: "light",
          title: "Ce que nous recherchons",
          items: [
            { title: "Rigueur intellectuelle", desc: "Le goût de l'analyse documentée et de la recommandation argumentée." },
            { title: "Esprit international", desc: "L'aisance dans les environnements multi-juridictions et multiculturels." },
            { title: "Profondeur opérationnelle", desc: "L'envie de voir les mandats aboutir, pas seulement de les conseiller." },
            { title: "Collaboration", desc: "Le travail entre disciplines et entre géographies, sans ego." },
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Postuler",
          paragraphs: [
            "Nous publions peu de postes : nous recrutons peu, et bien. Si vous partagez nos valeurs et souhaitez travailler sur des mandats complexes aux côtés d'une équipe senior, écrivez-nous à contact@columbusmanagementconsulting.com avec votre parcours et vos motivations.",
            "Toutes les candidatures sont traitées dans la plus stricte confidentialité.",
          ],
        },
      ],
    },
    en: {
      eyebrow: "The Firm · Careers",
      title: "Build your career on mandates that matter.",
      intro:
        "We look for people who combine analytical rigour, a global perspective and genuine curiosity about markets, real estate and capital.",
      chips: ["Zurich", "Senior team"],
      sections: [
        {
          type: "grid",
          theme: "light",
          title: "What we look for",
          items: [
            { title: "Intellectual rigour", desc: "A taste for documented analysis and argued recommendation." },
            { title: "Global mindset", desc: "Ease in multi-jurisdictional and multicultural environments." },
            { title: "Operational depth", desc: "The drive to see mandates through, not just advise on them." },
            { title: "Collaboration", desc: "Work across disciplines and geographies, without ego." },
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Apply",
          paragraphs: [
            "We rarely publish openings: we hire seldom, and well. If you share our values and want to work on complex mandates alongside a senior team, write to us at contact@columbusmanagementconsulting.com with your background and motivation.",
            "All applications are handled in strict confidence.",
          ],
        },
      ],
    },
    de: {
      eyebrow: "Das Unternehmen · Karriere",
      title: "Bauen Sie Ihre Karriere an Mandaten auf, die zählen.",
      intro:
        "Wir suchen Menschen, die analytische Präzision, internationale Perspektive und aufrichtige Neugier für Märkte, Immobilien und Kapital verbinden.",
      chips: ["Zürich", "Senior-Team"],
      sections: [
        {
          type: "grid",
          theme: "light",
          title: "Was wir suchen",
          items: [
            { title: "Intellektuelle Präzision", desc: "Freude an dokumentierter Analyse und begründeter Empfehlung." },
            { title: "Internationale Denkweise", desc: "Souveränität in multi-jurisdiktionellen und multikulturellen Umgebungen." },
            { title: "Operative Tiefe", desc: "Der Wille, Mandate zum Abschluss zu bringen — nicht nur zu beraten." },
            { title: "Zusammenarbeit", desc: "Arbeit über Disziplinen und Geografien hinweg, ohne Ego." },
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Bewerben",
          paragraphs: [
            "Wir veröffentlichen selten Stellen: Wir stellen selten ein, dafür gezielt. Wenn Sie unsere Werte teilen und an komplexen Mandaten an der Seite eines Senior-Teams arbeiten möchten, schreiben Sie uns an contact@columbusmanagementconsulting.com mit Ihrem Werdegang und Ihrer Motivation.",
            "Alle Bewerbungen werden streng vertraulich behandelt.",
          ],
        },
      ],
    },
  },
];
